function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M14.285 10.156 23.22 0h-2.117l-7.758 8.82L7.148 0H0l9.371 13.336L0 23.988h2.117l8.192-9.312 6.543 9.312H24l-9.719-13.832Zm-2.902 3.297-.95-1.328L2.88 1.559h3.254l6.094 8.527.949 1.328L21.102 22.5h-3.254Zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#000",
    fillOpacity: 1
  }
}));
export { SvgTwitterSmall as ReactComponent };
export default __webpack_public_path__ + "static/media/twitterSmall.def734ac.svg";